<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="img/consultoria/LogoJunto3.0.png" class="img-fluid">
                        <p class="lead text-white mt-4 mb-5">Asesoría y Capacitación en Seguridad, Salud Laboral, Ambiente y
                            Producción Industrial
                        </p>
                        <i class="lead text-white mt-4 mb-5">
                            “Construimos una cultura de prevención y excelencia industrial en todo el Ecuador.”
                        </i>
                    </div>
                </div>
                <br><br>
                <br><br>
                <div class="row align-items-center justify-content-around stars-and-coded">
                     
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style></style>
